/* c-article-column — 目次自動生成 + リンクコピー */
(function () {
  'use strict';

  /* 目次: 本文の h2 から自動生成。h2 が2つ未満なら目次ボックスごと非表示 */
  function buildToc() {
    var content = document.querySelector('.js-c-article-content');
    var tocList = document.querySelector('.js-c-toc-list');
    var tocBox = document.querySelector('.js-c-toc');
    if (!content || !tocList || !tocBox) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) {
      tocBox.style.display = 'none';
      return;
    }

    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) h.id = 'c-toc-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/^[0-9０-９]+[\.．]\s*/, '');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById(h.id).scrollIntoView({ behavior: 'smooth' });
        history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      tocList.appendChild(li);
    });
  }

  /* リンクコピー */
  function bindCopyLink() {
    var btn = document.querySelector('.js-c-copy-link');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = window.location.href.split('#')[0];
      var done = function () {
        btn.classList.add('is-copied');
        btn.setAttribute('aria-label', 'コピーしました');
        setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.setAttribute('aria-label', 'リンクをコピー');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      buildToc();
      bindCopyLink();
    });
  } else {
    buildToc();
    bindCopyLink();
  }
})();
